// extracted by mini-css-extract-plugin
module.exports = {"root":"SliderProdotti_root__gEzb2","item":"SliderProdotti_item__RdAVx","rotation":"SliderProdotti_rotation__WFRL0"};